/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Insert_Missing_HelpInputs */



/**
* | output |
* | --- |
* | "When an event in the source group has no match, insert a copy into the destination group." |
*
* @param {Event_Group_Sync_Insert_Missing_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_insert_missing_help = /** @type {((inputs?: Event_Group_Sync_Insert_Missing_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Insert_Missing_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("When an event in the source group has no match, insert a copy into the destination group.")
	if (locale === "de") return /** @type {LocalizedString} */ ("When an event in the source group has no match, insert a copy into the destination group.")
	if (locale === "it") return /** @type {LocalizedString} */ ("When an event in the source group has no match, insert a copy into the destination group.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("When an event in the source group has no match, insert a copy into the destination group.")
	if (locale === "es") return /** @type {LocalizedString} */ ("When an event in the source group has no match, insert a copy into the destination group.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("When an event in the source group has no match, insert a copy into the destination group.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("When an event in the source group has no match, insert a copy into the destination group.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("When an event in the source group has no match, insert a copy into the destination group.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("When an event in the source group has no match, insert a copy into the destination group.")
	return /** @type {LocalizedString} */ ("When an event in the source group has no match, insert a copy into the destination group.")
});